import { addAlphaToColor, lightenDarkenColor } from "utils"

const addIframeChangeThemeListener = () => {
  const iframeWindowParentHost =
    window.location.host.split("-panel.")[1]

  // for iframe in panel change theme page
  const changeThemeColorForPreview = (event) => {
    if (process.env.NODE_ENV === "production") {
      if (!event.origin.includes("-panel")) return

      if (!event.origin.includes(iframeWindowParentHost)) return
    }

    if (event.data.type !== "change-theme-color") return

    const colorsMap = event.data.data

    const keys = Object.keys(colorsMap)

    keys.forEach(key => {
      const mainColor = colorsMap[key]

      const mainColorDark = lightenDarkenColor(mainColor, -45)

      const mainColorAlpha25 = addAlphaToColor(mainColor, 0.25)

      document.querySelector(":root").style.setProperty(`--color-${key}`, mainColor)

      document.querySelector(":root").style.setProperty(`--color-${key}-dark`, mainColorDark)

      document.querySelector(":root").style.setProperty(`--color-${key}-alpha-25`, mainColorAlpha25)
    })
  }

  window.addEventListener(
    "message",
    changeThemeColorForPreview,
    false
  )
}

export default addIframeChangeThemeListener